export default __webpack_public_path__ + "static/menu-fighter2-07efba5a649525abb284efa7fb1d5bbe.png";